import { render, staticRenderFns } from "./HowItWorksNew.vue?vue&type=template&id=56f50b23&scoped=true&"
import script from "./HowItWorksNew.vue?vue&type=script&lang=ts&"
export * from "./HowItWorksNew.vue?vue&type=script&lang=ts&"
import style0 from "./HowItWorksNew.vue?vue&type=style&index=0&id=56f50b23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f50b23",
  null
  
)

export default component.exports